import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface IMenuItem {
  title: string; // Used as display text for item and title for separator type
  description: string;
  type: string; // Possible values: link/dropDown/extLink
  state?: string; // Router state
  icon: string; // Material icon name
  sub?: IChildItem[]; // Dropdown items
  active?: boolean;
  canAccess?: boolean;
}
export interface IChildItem {
  type?: string;
  title: string; // Display text
  state?: string; // Router state
  canAccess?: boolean;
}

interface ISidebarState {
  sidenavOpen?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  public sidebarState: ISidebarState = {
    sidenavOpen: true,
  };

  defaultMenu: IMenuItem[] = [
    // {
    //   title: 'sideBar.centerProfile',
    //   type: 'link',
    //   icon: `
    //   <g id="labs-radiology-centers-icon" transform="translate(-498 -190)" opacity="0.9">
    //   <path id="Path_13074" data-name="Path 13074" d="M22.794,18.952c2.262-1.039,2.825-6.555,1.5-9.646-.728-1.7-1.713-1.953-2.236-1.953s-1.507.254-2.236,1.953a11.289,11.289,0,0,0,0,7.858,3.2,3.2,0,0,0,1.5,1.788v4.577H17.647V2.941H16.176V0H5.882V2.941H4.412V5.882H0V25H25V23.529H22.794Zm-2.206-5.717c0-2.737.952-4.412,1.471-4.412s1.471,1.675,1.471,4.412-.952,4.412-1.471,4.412S20.588,15.972,20.588,13.235ZM7.353,1.471h7.353V2.941H7.353ZM4.412,23.529H1.471V7.353H4.412Zm5.147,0V19.118H12.5v4.412Zm6.618,0H13.971V17.647H8.088v5.882H5.882V4.412H16.176Z" transform="translate(498 190)"/>
    //   <path id="Path_13075" data-name="Path 13075" d="M150,120h1.471v1.471H150Z" transform="translate(355.353 75.882)" opacity="0.9"/>
    //   <path id="Path_13076" data-name="Path 13076" d="M210,120h1.471v1.471H210Z" transform="translate(298.294 75.882)" opacity="0.9"/>
    //   <path id="Path_13077" data-name="Path 13077" d="M270,120h1.471v1.471H270Z" transform="translate(241.235 75.882)" opacity="0.9"/>
    //   <path id="Path_13078" data-name="Path 13078" d="M150,180h1.471v1.471H150Z" transform="translate(355.353 18.824)" opacity="0.6"/>
    //   <path id="Path_13079" data-name="Path 13079" d="M210,180h1.471v1.471H210Z" transform="translate(298.294 18.824)" opacity="0.6"/>
    //   <path id="Path_13080" data-name="Path 13080" d="M270,180h1.471v1.471H270Z" transform="translate(241.235 18.824)" opacity="0.6"/>
    //   <path id="Path_13081" data-name="Path 13081" d="M150,240h1.471v1.471H150Z" transform="translate(355.353 -38.235)" opacity="0.8"/>
    //   <path id="Path_13082" data-name="Path 13082" d="M210,240h1.471v1.471H210Z" transform="translate(298.294 -38.235)" opacity="0.5"/>
    //   <path id="Path_13083" data-name="Path 13083" d="M270,240h1.471v1.471H270Z" transform="translate(241.235 -38.235)"/>
    //   <path id="Path_13084" data-name="Path 13084" d="M150,300h1.471v1.471H150Z" transform="translate(355.353 -95.294)" opacity="0.2"/>
    //   <path id="Path_13085" data-name="Path 13085" d="M210,300h1.471v1.471H210Z" transform="translate(298.294 -95.294)" opacity="0.8"/>
    //   <path id="Path_13086" data-name="Path 13086" d="M270,300h1.471v1.471H270Z" transform="translate(241.235 -95.294)" opacity="0.3"/>
    // </g>
    // `,
    //   state: '/admin/labProfile',
    //   description: ''
    // },
    {
      title: 'sideBar.usersManagement',
      type: 'dropDown',
      state: '/admin/all-users',
      icon: `
      <g id="users-icon" transform="translate(-1604 -235)" opacity="0.9">
        <path id="Path_13087" data-name="Path 13087" d="M21.338,231.583H18.891a3.608,3.608,0,0,0-.962.131,3.661,3.661,0,0,0-3.265-2.034H10.337a3.661,3.661,0,0,0-3.265,2.034,3.608,3.608,0,0,0-.962-.131H3.662A3.69,3.69,0,0,0,0,235.293v5.963a2.214,2.214,0,0,0,2.2,2.226H22.8a2.214,2.214,0,0,0,2.2-2.226v-5.963A3.69,3.69,0,0,0,21.338,231.583ZM6.675,233.39V242H2.2a.738.738,0,0,1-.732-.742v-5.963a2.214,2.214,0,0,1,2.2-2.226H6.109a2.163,2.163,0,0,1,.575.078C6.679,233.226,6.675,233.308,6.675,233.39ZM16.86,242H8.14V233.39a2.214,2.214,0,0,1,2.2-2.226h4.326a2.214,2.214,0,0,1,2.2,2.226Zm6.675-.742A.738.738,0,0,1,22.8,242H18.325V233.39c0-.082,0-.164-.009-.245a2.166,2.166,0,0,1,.575-.078h2.447a2.214,2.214,0,0,1,2.2,2.226Z" transform="translate(1604 14.518)"/>
        <path id="Path_13088" data-name="Path 13088" d="M36.668,126.5a3.3,3.3,0,1,0,3.254,3.3A3.279,3.279,0,0,0,36.668,126.5Zm0,5.109a1.813,1.813,0,1,1,1.789-1.813A1.8,1.8,0,0,1,36.668,131.613Z" transform="translate(1572.218 112.59)" opacity="0.6"/>
        <path id="Path_13089" data-name="Path 13089" d="M171.31,43.729a4.4,4.4,0,1,0,4.348,4.4A4.381,4.381,0,0,0,171.31,43.729Zm0,7.325a2.921,2.921,0,1,1,2.883-2.92A2.9,2.9,0,0,1,171.31,51.054Z" transform="translate(1445.19 191.271)"/>
        <path id="Path_13090" data-name="Path 13090" d="M348.548,126.5a3.3,3.3,0,1,0,3.254,3.3A3.279,3.279,0,0,0,348.548,126.5Zm0,5.109a1.813,1.813,0,1,1,1.789-1.813A1.8,1.8,0,0,1,348.548,131.613Z" transform="translate(1275.566 112.59)" opacity="0.6"/>
      </g>
    `,
      sub: [
        {
          title: 'sideBar.restaurantUsers',
          state: '/admin/users/restaurant-users',
          type: 'link',
        },
        // {
        //   title: 'Scanning Centers Users',
        //   state: '/admin/users/scanning-centers',
        //   type: 'link'
        // },
        {
          title: 'sideBar.systemUsers',
          state: '/admin/users/virtual-lab',
          type: 'link',
        },
        // {
        //   title: 'Hospitals Users',
        //   state: '/admin/users/hospital',
        //   type: 'link'
        // },
        // {
        //   title: 'Clinics Users',
        //   state: '/admin/users/clinic',
        //   type: 'link'
        // }
        // {
        //   title: 'Pathologist',
        //   state: '/admin/users/pathologist',
        //   type: 'link'
        // }
        {
          title: 'sideBar.staffDirectoryUsers',
          type: 'link',
          state: '/admin/users/labStaff',
        },
      ],
      description: ''
    },
    {
      title: 'supportTicket.supportTickets',
      type: 'link',
      icon: `
        <path id="ticket" d="M24034.85,15317.859H24025a1.887,1.887,0,0,1-1.418-.6,2.022,2.022,0,0,1-.588-1.455v-2.689a1.045,1.045,0,0,1,.135-.507.846.846,0,0,1,.383-.345,4.127,4.127,0,0,0,1.422-1.391,3.75,3.75,0,0,0,0-3.881,4.135,4.135,0,0,0-1.422-1.391.84.84,0,0,1-.383-.34,1.05,1.05,0,0,1-.135-.512v-2.684a2.02,2.02,0,0,1,.588-1.455,1.886,1.886,0,0,1,1.418-.6h18.314a1.9,1.9,0,0,1,1.418.6,2,2,0,0,1,.586,1.455l.023,2.845c-.225-.119-.471-.234-.732-.344-.178-.072-.344-.134-.506-.188l-.023-2.312a.794.794,0,0,0-.217-.566.743.743,0,0,0-.549-.221H24025a.757.757,0,0,0-.551.221.809.809,0,0,0-.215.566v2.468a5.235,5.235,0,0,1,1.816,1.865,5.147,5.147,0,0,1,0,5.071,5.21,5.21,0,0,1-1.816,1.865v2.469a.785.785,0,0,0,.215.561.726.726,0,0,0,.551.222h8.873a8.32,8.32,0,0,0,.971,1.275Z" transform="translate(-24022.998 -15300.003)"/>
        <path id="request" d="M168.047-826.641h-1.3a6.547,6.547,0,0,1-4.784-1.944A6.406,6.406,0,0,1,160-833.317a6.418,6.418,0,0,1,1.965-4.736A6.538,6.538,0,0,1,166.747-840a6.676,6.676,0,0,1,2.637.521,6.791,6.791,0,0,1,2.144,1.429,6.722,6.722,0,0,1,1.443,2.119,6.476,6.476,0,0,1,.527,2.611,8.732,8.732,0,0,1-1.2,4.439,11.422,11.422,0,0,1-3.092,3.485.95.95,0,0,1-.372.118.65.65,0,0,1-.362-.079.811.811,0,0,1-.289-.246.636.636,0,0,1-.114-.363Zm-1.266-2.163a.636.636,0,0,0,.468-.193.636.636,0,0,0,.192-.466.623.623,0,0,0-.195-.463.649.649,0,0,0-.471-.19.635.635,0,0,0-.468.193.636.636,0,0,0-.192.466.623.623,0,0,0,.195.463A.649.649,0,0,0,166.781-828.8Zm-1.869-6.563a.4.4,0,0,0,.312-.008.577.577,0,0,0,.255-.218,1.323,1.323,0,0,1,.524-.48,1.647,1.647,0,0,1,.78-.179,1.633,1.633,0,0,1,1.077.343,1.142,1.142,0,0,1,.414.927,1.356,1.356,0,0,1-.177.677,3.6,3.6,0,0,1-.6.738,5.554,5.554,0,0,0-.832.958,1.455,1.455,0,0,0-.253.777.422.422,0,0,0,.116.3.369.369,0,0,0,.279.124.354.354,0,0,0,.274-.123.534.534,0,0,0,.131-.3,1.413,1.413,0,0,1,.3-.613,6.844,6.844,0,0,1,.626-.7,3.662,3.662,0,0,0,.726-.947,2,2,0,0,0,.219-.89,1.859,1.859,0,0,0-.639-1.474,2.381,2.381,0,0,0-1.624-.558,2.415,2.415,0,0,0-1.22.319,2.334,2.334,0,0,0-.839.762.471.471,0,0,0-.058.346A.307.307,0,0,0,164.912-835.367Z" transform="translate(-148.496 845.278)" opacity="0.8"/>
      `,
      state: '/admin/support-ticket',
      description: ''
    },
    {
      title: 'sideBar.restaurants',
      type: 'link',
      icon: `
  <g id="restaurants-lnactive-ic" transform="translate(-480.084 -519.959)">
    <path id="Path_19423" data-name="Path 19423" d="M491.784,530.652a1.008,1.008,0,1,0-1.43,1.42l8.071,7.662a1.012,1.012,0,0,0,1.416-1.445l-.006-.005Z" transform="translate(4.953 4.965)"/>
    <path id="Path_19424" data-name="Path 19424" d="M498.535,532.038a3.709,3.709,0,0,0,2.678-1.1l3.509-3.537a1.256,1.256,0,0,0,0-1.762,1.232,1.232,0,0,0-1.753-.008l-.007.008-3.546,3.524a1.233,1.233,0,0,1-1.753.006l-.007-.006h0l4.389-4.412a1.262,1.262,0,0,0,0-1.775,1.236,1.236,0,0,0-1.761,0l-4.377,4.424a1.256,1.256,0,0,1,0-1.762l3.509-3.537a1.262,1.262,0,0,0,0-1.775,1.236,1.236,0,0,0-1.761,0l-3.509,3.537a3.77,3.77,0,0,0,0,5.3h0l-1.612,1.612L482.28,520.4l-.124-.075a.839.839,0,0,0-.211-.138l-.223-.087-.149-.1h-.335a.668.668,0,0,0-.223,0,.855.855,0,0,0-.211.112l-.2.125h-.087l-.074.125a1.212,1.212,0,0,0-.136.212,1.322,1.322,0,0,0-.087.237v.138a13.815,13.815,0,0,0,3.856,11.673l3.273,3.287-6.708,6.749a1.257,1.257,0,0,0-.008,1.767l.008.008a1.25,1.25,0,0,0,1.761,0l7.526-7.474h0l3.509-3.537h0l2.48-2.5A3.706,3.706,0,0,0,498.535,532.038Zm-9.485,2.275-3.261-3.3a11.369,11.369,0,0,1-3.174-6.762l8.2,8.249Z" transform="translate(0 0)" />
  </g>
    `,
      state: '/admin/labs',
      description: ''
    },
    {
      title: 'sideBar.ourLabs',
      type: 'link',
      icon: `
      <g id="labs-radiology-centers-icon" transform="translate(-498 -190)" opacity="0.9">
      <path id="Path_13074" data-name="Path 13074" d="M22.794,18.952c2.262-1.039,2.825-6.555,1.5-9.646-.728-1.7-1.713-1.953-2.236-1.953s-1.507.254-2.236,1.953a11.289,11.289,0,0,0,0,7.858,3.2,3.2,0,0,0,1.5,1.788v4.577H17.647V2.941H16.176V0H5.882V2.941H4.412V5.882H0V25H25V23.529H22.794Zm-2.206-5.717c0-2.737.952-4.412,1.471-4.412s1.471,1.675,1.471,4.412-.952,4.412-1.471,4.412S20.588,15.972,20.588,13.235ZM7.353,1.471h7.353V2.941H7.353ZM4.412,23.529H1.471V7.353H4.412Zm5.147,0V19.118H12.5v4.412Zm6.618,0H13.971V17.647H8.088v5.882H5.882V4.412H16.176Z" transform="translate(498 190)"/>
      <path id="Path_13075" data-name="Path 13075" d="M150,120h1.471v1.471H150Z" transform="translate(355.353 75.882)" opacity="0.9"/>
      <path id="Path_13076" data-name="Path 13076" d="M210,120h1.471v1.471H210Z" transform="translate(298.294 75.882)" opacity="0.9"/>
      <path id="Path_13077" data-name="Path 13077" d="M270,120h1.471v1.471H270Z" transform="translate(241.235 75.882)" opacity="0.9"/>
      <path id="Path_13078" data-name="Path 13078" d="M150,180h1.471v1.471H150Z" transform="translate(355.353 18.824)" opacity="0.6"/>
      <path id="Path_13079" data-name="Path 13079" d="M210,180h1.471v1.471H210Z" transform="translate(298.294 18.824)" opacity="0.6"/>
      <path id="Path_13080" data-name="Path 13080" d="M270,180h1.471v1.471H270Z" transform="translate(241.235 18.824)" opacity="0.6"/>
      <path id="Path_13081" data-name="Path 13081" d="M150,240h1.471v1.471H150Z" transform="translate(355.353 -38.235)" opacity="0.8"/>
      <path id="Path_13082" data-name="Path 13082" d="M210,240h1.471v1.471H210Z" transform="translate(298.294 -38.235)" opacity="0.5"/>
      <path id="Path_13083" data-name="Path 13083" d="M270,240h1.471v1.471H270Z" transform="translate(241.235 -38.235)"/>
      <path id="Path_13084" data-name="Path 13084" d="M150,300h1.471v1.471H150Z" transform="translate(355.353 -95.294)" opacity="0.2"/>
      <path id="Path_13085" data-name="Path 13085" d="M210,300h1.471v1.471H210Z" transform="translate(298.294 -95.294)" opacity="0.8"/>
      <path id="Path_13086" data-name="Path 13086" d="M270,300h1.471v1.471H270Z" transform="translate(241.235 -95.294)" opacity="0.3"/>
    </g>
    `,
      state: '/admin/our-labs',
      description: ''
    }
  ];

  // sets iconMenu as default;
  menuItems = new BehaviorSubject<IMenuItem[]>([]);
  // navigation component has subscribed to this Observable
  // menuItems$ = this.menuItems.asObservable();

  constructor() { }
}
